import { motion } from "framer-motion";
import { fadeUp, staggerChild, staggerContainer } from "../lib/motion";

const outcomes = [
  { k: "Offers", v: "Easier to understand. Easier to sell." },
  { k: "Conversion", v: "More demand turns into actual buyers." },
  { k: "Monetization", v: "Independent of any single channel or launch." },
  { k: "Operations", v: "Fewer decisions for the creator to carry." },
  { k: "Delivery", v: "Cleaner. Less brittle under scale." },
  { k: "Revenue", v: "A foundation. Not a guess." },
  { k: "Growth", v: "Controlled. Not chaotic." },
];

export const Proof = () => {
  return (
    <section
      id="proof"
      data-testid="proof-section"
      className="relative py-24 md:py-32 lg:py-44 bg-[#101116] border-y border-[#282930]"
    >
      <div className="px-6 md:px-12 lg:px-20 max-w-[1500px] mx-auto">
        <div className="max-w-3xl">
          <motion.div {...fadeUp} className="flex items-center gap-3 mb-6">
            <span className="eyebrow">06 — Proof</span>
            <span className="block w-8 h-px bg-[#282930]" />
          </motion.div>
          <motion.h2
            {...fadeUp}
            className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight"
          >
            Once the backend is right, the shift is{" "}
            <span className="italic text-[#C9A26B]">hard to miss.</span>
          </motion.h2>
        </div>

        <motion.div
          {...staggerContainer}
          className="mt-16 lg:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#282930] border border-[#282930]"
        >
          {outcomes.map((o, i) => (
            <motion.div
              {...staggerChild}
              key={o.k}
              className="bg-[#0D0E12] p-8 lg:p-10 flex flex-col justify-between min-h-[180px] group hover:bg-[#16171B] transition-colors duration-300"
            >
              <div className="flex items-center justify-between">
                <span className="font-display text-3xl text-[#C9A26B]/60 group-hover:text-[#C9A26B] transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="eyebrow text-[#A8A39D] text-[10px]">{o.k}</span>
              </div>
              <p className="mt-6 text-[#F4EFE6] text-lg leading-snug font-display">
                {o.v}
              </p>
            </motion.div>
          ))}
        </motion.div>

        <motion.p
          {...fadeUp}
          className="mt-16 max-w-3xl text-[#F4EFE6] text-lg md:text-xl leading-relaxed"
        >
          Chadow Marketing is built to make a creator business feel{" "}
          <span className="italic font-display text-[#C9A26B]">
            tighter, sharper, and more scalable
          </span>
          —without changing the face of the brand.
        </motion.p>
      </div>
    </section>
  );
};

export default Proof;
